/**
 * Sharing Field
 *
 * Shared permission selector for user-created sidebar resources.
 *
 * Primary responsibilities:
 * - Offer private, workspace, and public visibility
 * - Keep toggle state stable when Radix clears a selected value
 *
 * Dependencies:
 * - ToggleGroup
 */

import { Label } from '@/components/ui/label'
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'

export function SharingField({
  value,
  onChange
}: {
  value: string
  onChange: (value: string) => void
}) {
  return (
    <div className="flex-start flex flex-col space-y-1 pt-2">
      <Label>Permissions</Label>
      <ToggleGroup
        className={'justify-start'}
        variant={'outline'}
        value={value}
        onValueChange={(nextValue) => {
          if (nextValue) {
            onChange(nextValue)
          }
        }}
        type={'single'}
      >
        <ToggleGroupItem value={'private'}>Private</ToggleGroupItem>
        <ToggleGroupItem value={'workspace'}>Workspace</ToggleGroupItem>
        <ToggleGroupItem value={'public'}>Public</ToggleGroupItem>
      </ToggleGroup>
    </div>
  )
}
